import Loader from "components/DesignSystem/Loader/loader";
import { Button } from "components/DesignSystem/Button/Button";
import { ArrowRightUpV2 } from "components/icons/ArrowUpRightV2";
import { DocumentPreviewModal } from "components/PreviewModal";
import { ReferralTable } from "components/Refer/ReferralTable";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useQuery } from "hooks/useQuery";
import { useLocation, useRouteMatch } from "react-router-dom";
import { useGetCreditsQuery } from "store/apis/refrral";
import { ReferralBanner } from "./ReferralBanner";
import { ConditionalLink } from "components/conditionalLink";

export const RefferalTabPage = () => {
  const query = useQuery();
  const page = Number(query.get("page")) || 1;
  const { uuid: groupId } = useCurrentGroupContext();
  const { url } = useRouteMatch();
  const location = useLocation();

  const { isLoading, isSuccess } = useGetCreditsQuery(
    { groupId, pageNum: page },
    { skip: !groupId }
  );

  if (isLoading || !isSuccess) {
    return <Loader />;
  }

  return (
    <div className="t-pb-16 t-flex t-flex-col t-gap-8">
      <ReferralBanner />
      <div>
        <div className="sm:t-mb-4 t-flex t-items-center t-justify-between">
          <div className="t-text-subtitle-lg t-text-text-100">
            Referral History
          </div>
          <ConditionalLink
            target="_blank"
            to={url.replace("referralrewards", "credits") + location.search}
            rel="noreferrer"
            className="t-no-underline"
          >
            <Button size="xsmall" customType="link">
              <div className="t-flex t-items-center t-gap-1.5">
                View my credits
              </div>
            </Button>
          </ConditionalLink>
        </div>
        <ReferralTable />
      </div>
      <DocumentPreviewModal />
    </div>
  );
};
